import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import R from 'ramda';
import StandardLayout from '../../templates/StandardLayout';

const QuizPage = ({ scriptSrc, metaInformation: { metaTitle }, link }) => (
  <StandardLayout>
    <iframe title={metaTitle} className="quiz-iframe" src={scriptSrc} />
    <div className="quiz-grid">
      <a
        className="quiz-link"
        href={link.href}
        target="_blank"
        rel="noreferrer"
      >
        {link.title}
      </a>
    </div>
  </StandardLayout>
);

QuizPage.propTypes = {
  scriptSrc: PropTypes.string,
  metaInformation: PropTypes.shape({
    metaTitle: PropTypes.string,
  }),
  link: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default connect(({ content }) => ({
  scriptSrc: R.prop('scriptSrc', content),
  metaInformation: R.prop('metaInformation', content),
  link: R.prop('link', content),
}))(QuizPage);
